import * as recycleApi from '../../api/recycleApi'

const state={
    storeInput:{
    },
     storeOutput:{
        isMulti:false,
        stores:[],
        StoreId:'',
        Name:'',
        hasError:false
    },
    qrcodeInput:{
        storeid:'',
        storename:''
    },
    qrcodeOutput:{
      qrCode:'',
      qrCodeSrc:'',
      hasError:false
    }
}

const getters={

}

const actions ={
    async getStoreList({commit},storeInput){
        const response =await recycleApi.getStoreList();
        commit('setStore',response)
        return response
    },
    async getQrcode({commit},qrcodeInput){
        const response =await recycleApi.getQrcode(qrcodeInput);
        commit('setQrcode',response)
        return response
    }
}

const mutations ={
    setStore(state,data){
        if(data.Status){
            let stores=data.Data
            state.storeOutput.stores=stores
            if(stores.length>1){
                state.storeOutput.isMulti=true
            }

            if(stores.length>0){
                state.storeOutput.StoreId=stores[0].StoreId
                state.storeOutput.Name=stores[0].Name
            }
            //console.log(state.storeOutput)
        }
        else{
            state.storeOutput.hasError=true
        }
    },
    setQrcode(state,data){
        if(data.Status){
        state.qrcodeOutput.qrCode=data.Data.QrcodeBase64
        state.qrcodeOutput.qrCodeSrc=data.Data.QrcodeSrc
        }else{
            state.qrcodeOutput.hasError=true
        }
    }
  
}

export default{
     namespaced:true,
     getters,
     state,
     actions,
     mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/recycle.js